<template>
    <!-- 팝업 -->
    <div class="pop_up_layer" style="display: block" @click="closeModal"></div>
    <div class="pop_up pop_detail preview" style="display: block; height: 80%; position: fixed">
        <button class="close_btn" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <div class="_intro sub_page" style="max-height: 100%; overflow-y: auto">
            <section class="sub_page_tit">
                <div class="banner_wrap wrap_1120">
                    <h2>소개</h2>
                </div>

                <div class="sub_menu_tab wrap_1120" v-html="state.header"></div>
            </section>
            <section class="sub_page_con wrap_1120">
                <div class="bread_crumbs">
                    <a href="" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></a>
                    <span class="icon_wrap"><img src="img/part_icon.png" alt="소개" /></span>
                    <a href="">소개</a>
                    <span class="icon_wrap"><img src="img/part_icon.png" alt="자주묻는 질문(FAQ)" /></span>
                    <router-link to="/intro">자주묻는 질문(FAQ)</router-link>

                    <span class="icon_wrap"><img src="img/part_icon.png" alt="서울시 인터넷시민감시단 참여 신청은 어디서 하나요?" /></span>
                    <span class="faq_title">{{ state.title }}</span>
                </div>
                <div class="sub_page_con_view con_view">
                    <div class="tit_wrap flex_wrap">
                        <span class="con_tit">{{ state.title }}</span>
                    </div>
                    <div class="content_wrap" v-html="state.content"></div>

                    <div class="btn_wrap _default right_btn _board_type">
                        <button class="common_btn" type="button">목록</button>
                    </div>
                </div>

                <!-- <div class="list_wrap">
                    <a href="javascript:void(0)" class="next_list">
                        <span>다음글</span>
                        <div class="list_tit elips_1">다음글 ...</div>
                        <div class="list_date">{{ CommonUtils.dateFormat(new Date(), ".", false) }}</div>
                    </a>

                    <a href="javascript:void(0)" class="prev_list">
                        <span>이전글</span>
                        <div class="list_tit elips_1">이전글 ...</div>
                        <div class="list_date">{{ CommonUtils.dateFormat(new Date(), ".", false) }}</div>
                    </a>
                </div> -->
            </section>
        </div>
    </div>
    <!-- 팝업 -->
</template>
<script lang="ts" config>
    import { reactive, router, apiService, onMounted, onUnmounted, watch, computed, CommonUtils, ref } from "@/BaseComponent";

    export default {
        props: {
            header: {
                type: Object,
                default: "",
            },
            title: {
                type: String,
                default: "",
            },

            content: {
                type: String,
                default: "",
            },
        },
        emits: ["close"],
        components: {},
        setup(props: any, { emit }: any) {
            const state = reactive({
                title: "" as string,
                content: "" as string,
                header: "" as string,
            });

            onMounted(() => {
                state.title = props.title;
                state.content = props.content;
                state.header = props.header;

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            watch(props, () => {
                state.title = props.title;
                state.content = props.content;
                state.header = props.header;
            });

            const closeModal = () => {
                emit("close");
            };

            return { state, closeModal, CommonUtils };
        },
    };
</script>

<style scoped>
    .textarea {
        width: 100%;
    }

    .pop_up.preview {
        width: 100%;
        max-width: 60%;
    }

    .list_wrap a[class*="_list"]:nth-child(2) {
        border-top: 1px solid #c4c4c4;
    }

    .list_wrap a[class*="_list"] {
        display: flex;
        gap: 10px;
        padding: 10px 0;
        position: relative;
        cursor: pointer;
    }

    .list_wrap a[class*="_list"]:hover {
        background-color: #fafafa;
    }

    .list_wrap a[class*="_list"] span {
        background-color: #fff9e9;
        padding: 3px 10px;
        color: #ff8935;
        font-weight: 500;
        font-size: 14px;
    }
</style>
